import { createContext, useContext, useState } from 'react';

import MessageDrawer from '../components/crm/message/crm.message.drawer';

const MessageDrawerContext = createContext({ openMessageDrawer: () => {} });

export const useMessageDrawer = () => useContext(MessageDrawerContext);

export const MessageDrawerProvider = ({ children }) => {

    const [messageRequest, setMessageRequest] = useState(null);

    const openMessageDrawer = ({ contact, opportunity, activity, scheduleOrigin = null, initialView, onSent, onScheduled, onSellerChanged }) =>
        setMessageRequest({ contact, opportunity, activity, scheduleOrigin, initialView, onSent, onScheduled, onSellerChanged });

    const closeMessageDrawer = () => setMessageRequest(null);

    return (
        <MessageDrawerContext.Provider value={{ openMessageDrawer }}>
            {children}

            {messageRequest && (
                <MessageDrawer
                    contact={messageRequest.contact}
                    opportunity={messageRequest.opportunity}
                    activity={messageRequest.activity}
                    scheduleOrigin={messageRequest.scheduleOrigin}
                    initialView={messageRequest.initialView}
                    onSent={messageRequest.onSent}
                    onScheduled={messageRequest.onScheduled}
                    onSellerChanged={messageRequest.onSellerChanged}
                    onExit={closeMessageDrawer}
                />
            )}
        </MessageDrawerContext.Provider>
    );
};
